/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getBonus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("course-student-bonus", { params: payload })
        .then((response) => {
          commit("SET_BONUS_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  addBonus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-student-bonus", payload)
        .then((response) => {
          commit("ADD_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateBonus({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-student-bonus/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
